import { GET_RU_SUB_LOT_BY_ID, LOAD_RU_SUB_LOTS, ADD_NEW_EMPTY_SUB_LOT, REFRESH_RU_SUB_LOT_IDS, UPDATE_RU_SUB_LOT_STORE, PUSH_RU_EMPTY_SUBLOT, ERASE_RU_SUB_LOTS, ERASE_RU_SUB_LOT_BY_ID } from '../../actions/types';
const initialState = {};


export default (state = initialState, action) => {
  switch (action.type) {

    case GET_RU_SUB_LOT_BY_ID:
      const newObj2 = JSON.parse(JSON.stringify(state));
      let payloadById = action.payload;

      newObj2[action.payload.nSubLotId].ShouldPersist = true;

      if (payloadById.NoVATInvoiceValue != null) {
        newObj2[action.payload.nSubLotId].NoVATInvoiceValueString = payloadById.NoVATInvoiceValue.toString();
      } else {
        newObj2[action.payload.nSubLotId].NoVATInvoiceValueString = "";
      }

      if (payloadById.PBOptionalsValue != null) {
        newObj2[action.payload.nSubLotId].PBOptionalsValueString = payloadById.PBOptionalsValue.toString();
      } else {
        newObj2[action.payload.nSubLotId].PBOptionalsValueString = "";
      }

      if (payloadById.InvoiceDiscountValue != null) {
        newObj2[action.payload.nSubLotId].InvoiceDiscountValueString = payloadById.InvoiceDiscountValue.toString();
      } else {
        newObj2[action.payload.nSubLotId].InvoiceDiscountValueString = "";
      }

      if (payloadById.OutOfInvoiceDiscountValue != null) {
        newObj2[action.payload.nSubLotId].OutOfInvoiceDiscountValueString = payloadById.OutOfInvoiceDiscountValue.toString();
      } else {
        newObj2[action.payload.nSubLotId].OutOfInvoiceDiscountValueString = "";
      }

      if (payloadById.AditionalMargin != null) {
        newObj2[action.payload.nSubLotId].AditionalMarginString = payloadById.AditionalMargin.toString();
      } else {
        newObj2[action.payload.nSubLotId].AditionalMarginString = "";
      }

      newObj2[action.payload.nSubLotId].AverageKm = payloadById.AverageKm;
      newObj2[action.payload.nSubLotId].LicensePlateRegistrationYear = payloadById.LicensePlateRegistrationYear;
      newObj2[action.payload.nSubLotId].ReferenceRentalPrice = payloadById.ReferenceRentalPrice;
      newObj2[action.payload.nSubLotId].Quantity = payloadById.Quantity;
      newObj2[action.payload.nSubLotId].Id = payloadById.Id;
      newObj2[action.payload.nSubLotId].L1ID = payloadById.L1ID;
      newObj2[action.payload.nSubLotId].L3Id = payloadById.L3Id;
      newObj2[action.payload.nSubLotId].LPGains = payloadById.LPGains;
      newObj2[action.payload.nSubLotId].LPGainsObservations = payloadById.LPGainsObservations;
      newObj2[action.payload.nSubLotId].LPGainsstring = payloadById.LPGainsstring;
      newObj2[action.payload.nSubLotId].LpGainsId = payloadById.LpGainsId;
      newObj2[action.payload.nSubLotId].NoVATInvoiceValue = payloadById.NoVATInvoiceValue;
      newObj2[action.payload.nSubLotId].NumA1 = payloadById.NumA1;
      newObj2[action.payload.nSubLotId].NumClientReferenceProposal = payloadById.NumClientReferenceProposal;
      newObj2[action.payload.nSubLotId].NumClientRefSchedule = payloadById.NumClientRefSchedule;
      newObj2[action.payload.nSubLotId].NumClientRefScheduleDate = payloadById.NumClientRefScheduleDate;
      newObj2[action.payload.nSubLotId].RappelDiscountDetail = payloadById.RappelDiscountDetail;
      newObj2[action.payload.nSubLotId].RappelDiscountId = payloadById.RappelDiscountId;
      newObj2[action.payload.nSubLotId].RappellDescription = payloadById.RappellDescription;
      newObj2[action.payload.nSubLotId].SMEDiscount = payloadById.SMEDiscount;
      newObj2[action.payload.nSubLotId].SubLotCarOptionals = payloadById.SubLotCarOptionals;
      newObj2[action.payload.nSubLotId].SubLotCarOptionalsDescription = payloadById.SubLotCarOptionalsDescription;
      newObj2[action.payload.nSubLotId].Username = payloadById.Username;
      newObj2[action.payload.nSubLotId].DiscountPercentage = payloadById.DiscountPercentage;
      newObj2[action.payload.nSubLotId].BusinessDiscount = payloadById.BusinessDiscount;
      newObj2[action.payload.nSubLotId].DiscountOutsideInvoice = payloadById.DiscountOutsideInvoice;
      newObj2[action.payload.nSubLotId].DiscountInvoice = payloadById.DiscountInvoice;

      return Object.assign({}, state, {
        ...newObj2
      });

    case ADD_NEW_EMPTY_SUB_LOT:
      return Object.assign({}, state, {
        ...action.payload
      });

    case LOAD_RU_SUB_LOTS:
      return Object.assign({}, state, {
        ...action.payload
      });

    case PUSH_RU_EMPTY_SUBLOT:
      return Object.assign({}, state, {
        ...action.payload
      });

    case UPDATE_RU_SUB_LOT_STORE:
      const newObj = JSON.parse(JSON.stringify(state));
      newObj[action.payload.nSubLotId][action.payload.propName] = action.payload.propValue;

      return Object.assign({}, state,
        newObj
      );

    case ERASE_RU_SUB_LOTS:
      return Object.assign({}, {}
      );

    case ERASE_RU_SUB_LOT_BY_ID:

      const stateCopy = JSON.parse(JSON.stringify(state));

      delete stateCopy[action.payload];

      return stateCopy;

    case REFRESH_RU_SUB_LOT_IDS:
      const newStateCopy = JSON.parse(JSON.stringify(state));
      var lotId = action.payload.lotId;
      if (action.payload.ColdToHotSubLotIdMap != null) {
        action.payload.ColdToHotSubLotIdMap.forEach(element => {
          // eslint-disable-next-line 
          if (element.HotId != element.ColdId) {
            delete newStateCopy[element.HotId];
          }
          newStateCopy[element.HotId] = newStateCopy[element.ColdId];
          newStateCopy[element.HotId].Id = element.HotId;
          newStateCopy[element.HotId].L1ID = lotId;
          // eslint-disable-next-line 
          if (element.HotId != element.ColdId) {
            delete newStateCopy[element.ColdId];
          }
        });
      }
      return newStateCopy;

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/RU/usedRentalsSubLotReducer.js